import {
  useAppSelector,
  selectExerciseWorkspace,
} from 'slices/commonSelectors';

export const useExerciseBasePath = () => {
  const selectedExercise: ExerciseWorkspace | undefined = useAppSelector(
    selectExerciseWorkspace
  );

  if (!selectedExercise?.id) {
    return null;
  }

  return `/prepare/${selectedExercise.id}`;
};
